import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const heroBanner = gql`
  fragment Collection_page_hero_banner on Collection_pageBodyHero_banner {
    type
    primary {
      title
      paragraph
      button_label
      button_link {
        ...externalLink
        ...documentLink
      }
      button_color
      sale_type
      sale_percentage
      sale_percentage_text
      sale_items
      sale_banner_color
      banner_bg_image
    }
  }
  ${documentLink}
  ${externalLink}
`;
